"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Home, Compass, Library, History, Bell, Heart } from "lucide-react";
import { MobileNavSheet, MobileNavItem } from "@/components/layout/mobile-nav-sheet";
import { ThemeToggle } from "@/components/theme/theme-toggle";
import { READER_NAV_ITEMS } from "@/lib/navigation/nav-registry";
import { useAuth } from "@/providers/auth-provider";
import { useUnreadNotificationCount } from "@/hooks/use-unread-notifications";
type ActivePage = "home" | "browse" | "library" | "history" | "fan-clubs";
const PAGE_ICONS: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  home: Home,
  browse: Compass,
  library: Library,
  history: History,
  "fan-clubs": Heart
};

/**
 * Mobile-only hamburger menu for the reader surface. Surfaces the reader nav
 * links (which are hidden on mobile in the bar) plus the Writer CTA in the
 * shared slide-out sheet.
 */
export function ReaderMobileMenu(t0) {
  const $ = _c(14);
  const {
    activePage: t1
  } = t0;
  const activePage = t1 === undefined ? "home" : t1;
  const [open, setOpen] = useState(false);
  const {
    user
  } = useAuth();
  const unread = useUnreadNotificationCount();
  const hasUnread = unread !== null && unread > 0;
  let t2;
  if ($[0] !== hasUnread) {
    t2 = hasUnread ? <span aria-hidden={true} className="absolute right-0.5 top-0.5 size-2 rounded-full bg-accent ring-2 ring-background" /> : undefined;
    $[0] = hasUnread;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== activePage) {
    t3 = READER_NAV_ITEMS.map(t4 => {
      const {
        id,
        label,
        href,
        page,
        disabled
      } = t4;
      const Icon = PAGE_ICONS[page ?? ""] ?? Compass;
      if (disabled) {
        return <span key={id} aria-disabled="true" className="mobile-nav__item mobile-nav__item--disabled opacity-50"><Icon className="size-5" /><span className="flex-1">{label}</span><span className="mobile-nav__badge">Soon</span></span>;
      }
      return <MobileNavItem key={id} href={href ?? "/"} icon={<Icon className="size-5" aria-hidden={true} />} active={page === activePage}>{label}</MobileNavItem>;
    });
    $[2] = activePage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hasUnread || $[5] !== unread || $[6] !== user) {
    t4 = user && <MobileNavItem href="/notifications" icon={<Bell className="size-5" aria-hidden={true} />} trailing={hasUnread ? <span className="mobile-nav__badge">{unread > 99 ? "99+" : unread}</span> : undefined}>Notifications</MobileNavItem>;
    $[4] = hasUnread;
    $[5] = unread;
    $[6] = user;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mobile-nav__item mobile-nav__item--static justify-between"><span>Theme</span><ThemeToggle /></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== open || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t6 = <MobileNavSheet open={open} onOpenChange={setOpen} triggerClassName="xl:hidden" triggerBadge={t2}>{t3}{t4}{t5}</MobileNavSheet>;
    $[9] = open;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}